import { render, staticRenderFns } from "./ProgramasPres.vue?vue&type=template&id=574dbb84"
import script from "./ProgramasPres.vue?vue&type=script&lang=js"
export * from "./ProgramasPres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports